/**
 * Фид игр Рублокса через микросервис api-storys.
 * (Пути эндпоинтов /kubikon3d/* — устаревшее имя из прошлой архитектуры,
 *  трогать нельзя; в текстах для людей платформа называется Рублокс.)
 *
 * Эндпоинты:
 *   GET /api-storys/kubikon3d/feed?page=1&per_page=24&sort=popular
 *       → {projects:[...], total}
 *   GET /api-storys/kubikon3d/trending?limit=N → {projects:[...]}
 *   GET /api-storys/kubikon3d/top-authors?limit=N
 *       → {authors:[{total_games,total_plays,total_likes}]}
 *
 * Поля проекта в фиде: id, title, author_username,
 *   thumbnail (data-URI base64 JPEG ~10КБ), play_count, likes_count,
 *   dislikes_count, genre, description, rating_percent, age_rating,
 *   multiplayer, created_at.
 */

import { request } from "./client";

const S = "/api-storys/kubikon3d";

/**
 * Лента опубликованных игр.
 * @param {object} opts — { page, perPage, sort }
 *   sort: "popular" | "new" | ... (по умолчанию popular)
 * @returns {Promise<{projects:Array, total:number}>}
 */
export async function getFeed({ page = 1, perPage = 24, sort = "popular" } = {}, signal) {
  const data = await request(
    `${S}/feed?page=${page}&per_page=${perPage}&sort=${encodeURIComponent(sort)}`,
    { signal }
  );
  return {
    projects: Array.isArray(data?.projects) ? data.projects : [],
    total: typeof data?.total === "number" ? data.total : 0,
  };
}

/** Популярные игры (для hero-коллажа / подборок). */
export async function getTrending(limit = 12, signal) {
  const data = await request(`${S}/trending?limit=${limit}`, { signal });
  return Array.isArray(data?.projects) ? data.projects : [];
}

/**
 * Агрегаты по авторам — нужны для счётчиков в hero
 * (всего игр / всего запусков / всего лайков на платформе).
 */
export async function getTopAuthors(limit = 100, signal) {
  const data = await request(`${S}/top-authors?limit=${limit}`, { signal });
  return Array.isArray(data?.authors) ? data.authors : [];
}

/**
 * Суммарная статистика платформы для hero-секции.
 * Складывает агрегаты всех авторов.
 * @returns {Promise<{games:number, plays:number, likes:number}>}
 */
export async function getPlatformStats(signal) {
  const authors = await getTopAuthors(100, signal);
  return authors.reduce(
    (acc, a) => ({
      games: acc.games + (a.total_games || 0),
      plays: acc.plays + (a.total_plays || 0),
      likes: acc.likes + (a.total_likes || 0),
    }),
    { games: 0, plays: 0, likes: 0 }
  );
}
